// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__c15934c2d63fa79ea4cc","cls2":"SimplePaperPodcast-cls2___545107f3eb95653bec8 SimplePaperPodcast-cls1__c15934c2d63fa79ea4cc"};